import { api } from '@/config/api'

const foldersBaseEndpoint = '/FolderApi'

export const getUserFolders = params => api.get(`${foldersBaseEndpoint}/GetAllByUser`, { params })

export const getUserResourceFolders = ({ id, locale }) => api.get(`${foldersBaseEndpoint}/ResourceInFolders/${id}`, { params: { locale } })

export const getFolderDetails = folderId => api.get(`${foldersBaseEndpoint}/GetByLocale/${folderId}`)

export const addResourceToFolder = data => api.post(`${foldersBaseEndpoint}/AddToFolder`, data)

export const deleteFolder = folderId => api.delete(`${foldersBaseEndpoint}/Delete/${folderId}`)

export const renameFolder = (id, name) => api.put(`${foldersBaseEndpoint}/Rename/${id}`, { name, id })

export const updateFolderDescription = ({ folderId, description }) => api.put(`${foldersBaseEndpoint}/${folderId}/Description`, `"${description}"`)

export const createFolder = name => api.post(`${foldersBaseEndpoint}/Create`, JSON.stringify(name))

export const shareFolder = (folderId, users, locale) => api.post(`${foldersBaseEndpoint}/Share`, { folderId, recipients: users }, { params: { locale } })

export const putUserResourceFolders = data => api.put(`${foldersBaseEndpoint}/UpdateResourceInFolders`, data, { params: { locale: data.locale } })

export const removeResourceFromFolder = (resourceId, folderId) =>
  api.delete(`${foldersBaseEndpoint}/${folderId}/Resource/${resourceId}`)

export const removeResourceFromAllFolders = resourceId =>
  api.delete(`${foldersBaseEndpoint}/RemoveFromAllFolders/${resourceId}`)

export const getUsersFromSchoolWithoutFolderInfo = filters =>
  api.get(`${foldersBaseEndpoint}/GetUsers`, { params: { ...filters } })

export const getUserPermissions = folderId => api.get(`${foldersBaseEndpoint}/UserPermissions`, { params: { folderId } })

export const updateUsersPermissions = (folderId, userPermissions) =>
  api.put(`${foldersBaseEndpoint}/UpdatePermissions`, { folderId, userPermissions })

export const updateUserPermissions = (folderId, user) =>
  api.put(`${foldersBaseEndpoint}/${folderId}/EditPermission`, user)

export const orderFolderResources = ({ folderId, resources }) => api.put(`${foldersBaseEndpoint}/${folderId}/OrderResources`, resources)
